export const highlightStyle = {
  background: `
     linear-gradient(61.28deg, #27926D -14.15%, #2DAB7F 96.59%),
     linear-gradient(81.12deg, #27926D 0%, #2EAC80 86.48%)`,
  height: '30px',
  width: '30px'
}

export const highlightContentStyle = {
  color: 'white',
  fontFamily: 'Effra-Regular'
}
